import React from 'react';
import { injectIntl } from 'react-intl';
import { Panel, Col } from 'react-bootstrap';
import { inject } from 'mobx-react';
import BlockSuggestBody from './BlockSuggestBody';


// @inject('suggestStore')
class SuggestBlock extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const { blockStore, suggestStore, intl } = this.props;
    return (
      <div>
        <h4>
          <i className="fa fa-lightbulb-o" aria-hidden="true" />
                            &nbsp;
          {intl.formatMessage({ id: 'suggests' })}
        </h4>
        <BlockSuggestBody blockStore={blockStore} suggestStore={suggestStore} />
      </div>
    );
  }
}


export default injectIntl(SuggestBlock);

{ /* <div className={"suggests-block lane lane-" + blockStore.name}>
                <Panel>
                    <Col xs={12} className="bmc-col-lane">
                        <div className="lane-list-container">
                            <h4><i className="fa fa-lightbulb-o" aria-hidden="true"/>
                                &nbsp;
                                {intl.formatMessage({id: 'suggests'})}
                            </h4>
                            <BlockSuggestBody blockStore={blockStore}/>
                        </div>
                    </Col>
                </Panel>
            </div> */ }
